import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { not } from 'ramda';
import useSWR from 'swr';
import { toLanguageFromLocale } from '@peloton/internationalize';
import { SubscriptionsFetchers } from '@webtv/data-fetch';
import { APP_VERSION_NUMBER, PELOTON_PLATFORM } from '@webtv/env';
import { useLocale } from '@webtv/internationalize';

var getOperatingSystemVersion = function getOperatingSystemVersion() {
  var _navigator$platform;

  if (typeof navigator === 'undefined') {
    return null;
  }

  var platform = (_navigator$platform = navigator.platform) !== null && _navigator$platform !== void 0 ? _navigator$platform : ''; // Sky devices will typically return `Linux armv7l` for platform

  var _platform$split = platform.split(' '),
      _platform$split2 = _slicedToArray(_platform$split, 2),
      osVersion = _platform$split2[1];

  return osVersion;
};
/**
 * A tuple containing BaseAnalyticsProperties and a boolean indicating whether or not some data may still be pending.
 * This is deliberately not a PendingResult (which may feel more idiomatic) because some data will _always_ be available (and may be sufficient for a given request)
 *
 * @see BaseAnalyticsProperties
 */


export var useBaseAnalyticsProperties = function useBaseAnalyticsProperties() {
  var _primarySub$id, _primarySub$owner$id, _primarySub$owner;

  var GetPrimarySubscription = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SubscriptionsFetchers.GetPrimarySubscription;

  var _GetPrimarySubscripti = GetPrimarySubscription({}),
      _GetPrimarySubscripti2 = _slicedToArray(_GetPrimarySubscripti, 3),
      endpoint = _GetPrimarySubscripti2[0],
      fetcher = _GetPrimarySubscripti2[1],
      config = _GetPrimarySubscripti2[2];

  var _useSWR = useSWR(endpoint, fetcher, config),
      subscriptionsData = _useSWR.data,
      subscriptionError = _useSWR.error;

  var pendingSubscriptions = !subscriptionsData && !subscriptionError;
  var primarySub = subscriptionsData !== null && subscriptionsData !== void 0 && subscriptionsData.hardwareSubscription ? _objectSpread(_objectSpread({}, subscriptionsData.hardwareSubscription), {}, {
    isDeviceSub: true
  }) : subscriptionsData === null || subscriptionsData === void 0 ? void 0 : subscriptionsData.digitalSubscription;
  var deviceLocale = useLocale();
  var deviceLanguage = toLanguageFromLocale(deviceLocale);
  return [{
    deviceLanguage: deviceLanguage,
    deviceLocale: deviceLocale,
    formFactor: 'TV',
    '[OS Version]': getOperatingSystemVersion(),
    platformType: toPlatformType(PELOTON_PLATFORM),
    sessionLocale: null,
    // TODO
    '[Subscription ID]': (_primarySub$id = primarySub === null || primarySub === void 0 ? void 0 : primarySub.id) !== null && _primarySub$id !== void 0 ? _primarySub$id : null,
    subscriptionOwner: (_primarySub$owner$id = primarySub === null || primarySub === void 0 ? void 0 : (_primarySub$owner = primarySub.owner) === null || _primarySub$owner === void 0 ? void 0 : _primarySub$owner.id) !== null && _primarySub$owner$id !== void 0 ? _primarySub$owner$id : null,
    subscriptionPaymentProvider: primarySub ? toPaymentProvider(primarySub) : null,
    subscriptionType: primarySub ? toSubscriptionType(primarySub) : null,
    appVersion: APP_VERSION_NUMBER !== null && APP_VERSION_NUMBER !== void 0 ? APP_VERSION_NUMBER : null,
    device: toPlatformType(PELOTON_PLATFORM),
    deviceOrientation: 'Landscape',
    deviceType: 'STB'
  }, pendingSubscriptions];
};

var toSubscriptionType = function toSubscriptionType(subscription) {
  if (isDigitalSub(subscription) && subscription.billingType === 'trial' || isIOSSub(subscription) && subscription.subscriptionType === 'free_trial') {
    return 'Digital Membership Free Trial';
  } else if (isDigitalSub(subscription) || isIOSSub(subscription)) {
    return 'Digital Membership Monthly';
  }

  return subscription.subscriptionType === 'consumer' ? 'Consumer Membership' : 'Commercial Membership';
};

var toPaymentProvider = function toPaymentProvider(subscription) {
  if (isDigitalSub(subscription)) {
    switch (subscription.billingType) {
      case 'trial':
        return 'None';

      case 'amazon':
        return 'Amazon';

      case 'apple':
        return 'iTunes';

      case 'google':
        return 'Google Play';
    }
  }

  return 'Credit Card';
};

var isDigitalSub = function isDigitalSub(subscription) {
  return 'billingType' in subscription;
};

var isIOSSub = function isIOSSub(subscription) {
  return 'subscriptionType' in subscription && not('isDeviceSub' in subscription);
};

var toPlatformType = function toPlatformType(platform) {
  switch (platform) {
    case 'sky_tv':
      return 'Sky TV';

    case 'lg':
      return 'LG';

    case 'samsung':
      return 'Samsung';

    default:
      return 'Web';
  }
};